import { Button, Typography } from '@mui/material'
import { FlexBoxProps, FlexGrowRow } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { EthersContext } from '../../Contexts'

const ConnectionBox: React.FC<FlexBoxProps> = ({ children, ...props }) => {
  const { provider, signer, isConnected, connect } = useContext(EthersContext)

  const onConnectClicked = async () => {
    await connect?.()
  }

  if ((isConnected === false && provider) || signer === null) {
    return (
      <FlexGrowRow {...props}>
        <Button onClick={onConnectClicked} variant="contained">
          <Typography variant="caption">Connect Wallet</Typography>
        </Button>
      </FlexGrowRow>
    )
  } else {
    return <>{children}</>
  }
}

export default ConnectionBox
